<template>
    <div class="news">
        <div class="headlines">
            <div class="text">
                <p @click="toDetail(headFrom.id)">{{languageType == 0?headFrom.name:headFrom.enName}}</p>
                <p>{{languageType == 0?headFrom.detail:headFrom.enDetail}}</p>
                <span>{{headFrom.addTime | filteraddTime}}</span>
            </div>
            <div class="pic">
                <img v-if="headFrom.pic" :src="headFrom.pic"/>
            </div>
            <p v-if="!headFrom.id">暂无内容</p>
        </div>
        <div class="newsList">
            <ul>
                <li v-for="(item,index) in newsList" :key="index" @click="toDetail(item.id)">
                    <div class="picture">
                        <img :src="item.pic"/>
                    </div>
                    <div class="main">
                        <div class="title">
                            <a>{{ languageType == 0?item.name:item.enName}}</a>
                        </div>
                        <p>{{ languageType == 0?item.detail:item.enDetail }}</p>
                        <span>{{ item.addTime | filteraddTime}}</span>
                    </div>
                </li>
            </ul>
            <div class="page">
                    <el-pagination
                    background
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="totalCount">
                    </el-pagination>
                    <div class="mount">
                        <span v-if="languageType == 0">共 {{ totalPage }} 页</span>
                        <span v-else>Total {{totalPage}} Page</span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            pageIndex: 1,
            pageSize: 5,
            totalPage: 0,
            totalCount:0,
            newsList:[],
            headFrom:{}
        }
    },
    created () {
        this.getExhibitionList()
    },
    filters:{
        filteraddTime (val) {
            let time = val == undefined?'':String(val).slice(0,10)
            return time
        }
    },
    methods:{
        getExhibitionList () {
            this.$http({
                url: this.$http.adornUrl('/web/news/list'),
                method: 'post',
                data: {
                    'page':String(this.pageIndex),
                    'limit':String(this.pageSize),
                    'type':2,
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.headFrom = data.page.list[0]
                    if(data.page.list.length > 1){
                        this.newsList = data.page.list.slice(1)
                    }
                    this.totalCount = data.page.totalCount
                    this.totalPage = data.page.totalPage
                } else {
                    this.newsList = []
                    this.totalPage = 1
                    this.totalCount = 0
                }
            })
        },
        toDetail (id) {
            sessionStorage.setItem('detailId',id)
            this.$router.push({ name:'exhibitiondetail'})
        },
         // 当前页
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getExhibitionList()
        },
    }
}
</script>

<style lang="less" scoped>
    .news {
        margin: 0 80px 90px 80px;
        .headlines {
            padding-top: 40px;
            overflow: hidden;
            border-bottom: 2px solid #afabaa;
            position: relative;
            .text {
                float: left;
                width: 480px;
                margin-top: 60px;
                height: 279px;
                position: relative;
                p:first-child:hover {
                     color: #e21711;
                }
                p:first-child {
                    text-align: left;
                    font-size: 25px;
                    color: #000000;
                    cursor: pointer;
                }
                p:nth-child(2) {
                    text-align: left;
                    font-size: 16px;
                    color: #000000;
                    line-height: 25px;
                    margin-top: 25px;
                    max-height: 150px;
                    overflow: hidden;
                }
                span {
                    position: absolute;
                    bottom: 58px;
                    right: 0;
                    display: block;
                   font-size: 20px;
                    color: #606060;
                    text-align: right;
                }
            }
            .pic {
                float: right;
                // margin-bottom: 50px;
                img {
                    width: 500px;
                    height: 279px;
                }
            }
        }
        .headlines > p{
                position: absolute;
                width: 300px;
                height: 100px;
                line-height: 100px;
                left: 50%;
                top: 50%;
                margin-top: -50px;
                margin-left: -150px;
                color: #606060;
                letter-spacing: 8px;
            }
        .newsList {
            ul {
                li {
                    width: 1060px;
                    height: 173px;
                    border-bottom: 1px solid #e2e0e0;
                    overflow: hidden;
                    cursor: pointer;
                    .picture {
                        margin-top: 27px;
                        float: left;
                        img {
                            width: 217px;
                            height: 120px;
                        }
                    }
                    .main {
                        width: 823px;
                        float: left;
                        margin-top: 27px;
                        margin-left: 20px;
                        .title {
                            &:hover {
                                a {
                                    color: #e21711;
                                }
                            }
                            text-align: left;
                            a {
                                font-size: 25px;
                                color: #000000;
                            }
                        }
                        p {
                            text-align: left;
                            font-size: 16px;
                            color: #606060;
                            line-height: 25px;
                            min-height: 50px;
                            overflow: hidden;
                            margin-top: 12px;
                            margin-bottom: 12px;
                        }
                        span {
                            display: block;
                            text-align: left;
                            font-size: 16px;
                            color: #606060;
                        }
                    }

                }
            }
            .page {
                    margin-top: 90px;
                    line-height: 30px;
                    padding-bottom: 90px;
                .mount {
                    display: inline-block;
                    span {
                        font-size: 15px;
                        color: #606060;
                    }
                }
            }
        }
    }
</style>
<style lang="less">
.page {
        .el-pagination {
            display: inline-block;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active{
                background-color:#e21711
        }
        .el-pagination.is-background .el-pager li {
            border: 1px solid #e21711;
            color: #e21711
        }
        .el-pagination.is-background .el-pager li:not(.active):hover{
            color: #e21711;
        }
        .el-pagination.is-background .btn-prev {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-left:before {
            color: #e21711;
        }
         .el-pagination.is-background .btn-next {
            border: 1px solid #e21711;
        }
        .el-icon-arrow-right:before {
            color: #e21711;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/exhibition.vue